// src/api.js
import axios from "axios";

const api = axios.create({
  baseURL: "https://api.3plwork.cloud/api"/*"http://localhost:8000/api"*/,
});

// Attach / remove token
export const setToken = (token) => {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common["Authorization"];
  }
};

// Auth
export const getMe = () => api.get("/me");

// ✅ REPORT APIs (FIXED)
export const getLoadEntryReport = (params) =>
  api.get("/reports/load-entry", { params });

export const getEmployeePayoutReport = (params) =>
  api.get("/reports/employee-payout", { params });

export const getInvoiceReport = (params) =>
  api.get("/reports/invoice", { params });

export default api;
